import React, { useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Input, Label, Row } from "reactstrap";
import usePersistStoreData from "../../../Components/Hooks/usePersistStoreData";
import { profile_update_passwordThunk } from "../../../slices/thunks";
import { useDispatch } from "react-redux";
import { showToast } from "../../../Components/ToastNotification";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ChangePasswordForm = React.memo(() => {
  const { userData } = usePersistStoreData();
  const token = userData?.token;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [passwordShow, setPasswordShow] = useState(false);
  const [newPasswordShow, setNewPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);
  const { profileUpdatePasswordData, profileUpdatePasswordLoading } =
    useSelector((state) => state.Profile_Update_Password);

  const validationSchema = Yup.object({
    oldPassword: Yup.string().required("Old password is required"),
    newPassword: Yup.string()
      .required("Please enter your new password")
      .min(8, "Password must be at least 8 characters!")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter!")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter!")
      .matches(/[0-9]/, "Password must contain at least one number!")
      .matches(
        /[\W_]/,
        "Password must contain at least one special character!"
      ), // \W matches any non-word character
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  return (
    <Formik
      initialValues={{
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        const params = {
          current_password: values.oldPassword,
          password: values.newPassword,
          password_confirmation: values.confirmPassword,
        };
        dispatch(profile_update_passwordThunk({ token, params }))
          .then((res) => {
            if (res?.payload?.code === 200) {
              showToast(res?.payload?.message, "success");
              navigate("/profile");
            } else {
              showToast(
                res?.payload || "Something went wrong, Please try again later",
                "error"
              );
            }
          })
          .catch((err) => {
            showToast(
              err?.response?.data?.message || "Something went wrong",
              "error"
            );
          });
      }}
    >
      {({ handleChange }) => (
        <Form>
          <Row className="g-2">
            <Col lg={4}>
              <div className="position-relative auth-pass-inputgroup">
                <Label htmlFor="oldPassword" className="form-label">
                  Old Password*
                </Label>
                <Input
                  type={passwordShow ? "text" : "password"}
                  id="oldPassword"
                  name="oldPassword"
                  onChange={handleChange}
                  placeholder="Enter old password"
                />
                <button
                  className=" btn btn-link eyeIcon position-absolute end-0  text-decoration-none text-muted eye_password_change"
                  onClick={() => setPasswordShow(!passwordShow)}
                  type="button"
                  id="password-addon"
                >
                  <i className={"ri-eye-fill align-middle"}></i>
                </button>
                <ErrorMessage
                  name="oldPassword"
                  component="div"
                  className="text-danger"
                />
              </div>
            </Col>

            <Col lg={4}>
              <div>
                <Label htmlFor="newPassword" className="form-label">
                  New Password*
                </Label>
                <Input
                   type={newPasswordShow ? "text" : "password"}
                  id="newPassword"
                  name="newPassword"
                  onChange={handleChange}
                  placeholder="Enter new password"
                />
                 <button
                  className=" btn btn-link eyeIcon position-absolute end-0  text-decoration-none text-muted eye_password_change"
                  onClick={() => setNewPasswordShow(!newPasswordShow)}
                  type="button"
                  id="password-addon"
                >
                  <i className={"ri-eye-fill align-middle"}></i>
                </button>
                <ErrorMessage
                  name="newPassword"
                  component="div"
                  className="text-danger"
                />
              </div>
            </Col>

            <Col lg={4}>
              <div>
                <Label htmlFor="confirmPassword" className="form-label">
                  Confirm Password*
                </Label>
                <Input
                   type={confirmPasswordShow ? "text" : "password"}
                  id="confirmPassword"
                  name="confirmPassword"
                  onChange={handleChange}
                  placeholder="Enter confirm password"
                />
                 <button
                  className=" btn btn-link eyeIcon position-absolute end-0  text-decoration-none text-muted eye_password_change"
                  onClick={() => setConfirmPasswordShow(!confirmPasswordShow)}
                  type="button"
                  id="password-addon"
                >
                  <i className={"ri-eye-fill align-middle"}></i>
                </button>
                <ErrorMessage
                  name="confirmPassword"
                  component="div"
                  className="text-danger"
                />
              </div>
            </Col>

            <Col lg={12}>
              <div className="text-end mt-3">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={profileUpdatePasswordLoading}
                  style={{
                    minWidth: "160px",
                  }}
                >
                  {profileUpdatePasswordLoading
                    ? "Loading..."
                    : "Change Password"}
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
});

export default ChangePasswordForm;
